"use client";

import { motion } from "framer-motion";
import { Shimmer } from "@/components/ai-elements/shimmer";
import { cn } from "@/lib/utils";

export function AssistantThinkingMessage({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={cn(
        "inline-flex max-w-full items-start text-sm text-foreground/70 transition-colors hover:text-foreground",
        className
      )}
    >
      <Shimmer>Thinking...</Shimmer>
    </div>
  );
}

export function AssistantLoader({ className }: { className?: string }) {
  return (
    <motion.div
      data-testid="message-assistant-loading"
      className={cn("w-full mx-auto max-w-3xl px-3 group/message", className)}
      initial={{ y: 5, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      data-role="assistant"
    >
      <div className="flex gap-4 w-full">
        <div className="flex flex-col gap-1">
          <AssistantThinkingMessage />
        </div>
      </div>
    </motion.div>
  );
}
